import { render, staticRenderFns } from "./MyWinAMiniGame.vue?vue&type=template&id=e51d70d4"
import script from "./MyWinAMiniGame.vue?vue&type=script&lang=js"
export * from "./MyWinAMiniGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports